import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ element }) => {
  const isAuthenticated = sessionStorage.getItem("userData") && sessionStorage.getItem("authToken");
  return isAuthenticated ? element : <Navigate to="/unauthorized" replace />;
};

export default ProtectedRoute;
